// @flow
import { QuestionOpinometroActionTypes } from './constants';

type QuestionOpinometroAction = { type: string, payload: {} | string };

// common success
export const questionOpinometroApiResponseSuccess = (actionType: string, data: any): QuestionOpinometroAction => ({
    type: QuestionOpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const questionOpinometroApiResponseError = (actionType: string, error: string): QuestionOpinometroAction => ({
    type: QuestionOpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getQuestionOpinometro = (id: string): QuestionOpinometroAction => ({
    type: QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO,
    payload: { id },
});

export const addQuestionOpinometro = (questionOpinometro:any):QuestionOpinometroAction=>({
    type:QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO,
    payload:questionOpinometro
})
export const updateQuestionOpinometro = (questionOpinometro:any):QuestionOpinometroAction=>({
    type:QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO,
    payload:questionOpinometro
})
export const deleteQuestionOpinometro = (id:string):QuestionOpinometroAction=>({
    type:QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO,
    payload:{id}
})

export const listQuestionOpinometro = (params:any): QuestionOpinometroAction => ({
    type: QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS,
    payload: params,
});


export const resetQuestionOpinometro = (): QuestionOpinometroAction => ({
    type: QuestionOpinometroActionTypes.RESET,
    payload: {},
});

